/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { DISCOUNT_CONSTANTS } from '../../../modules/discounts/reducers';
import { useDispatch } from 'react-redux';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import InputFormRest from '../../../components/Form/InputFormRest';
import CardBody from '../../../components/Card/CardBody';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import Card from '../../../components/Card/Card';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { configDefault } from '../../../core/config';
import { platformGroupsConstants } from '../../../modules/platformGroups/reducers';
import Pager from '../../../components/Adescom/PagerRange';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import FilterList from '../../../components/Filter/FilterList';
import AddButton from '../../../components/Buttons/AddButton';
import RemoveButton from '../../../components/Buttons/RemoveButton';
import { FilterReducerFieldName } from '../../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../../modules/filter/FilterListReducers';

interface CountryGroupSelectInterface {
    classes: any;
    editZone: any;
    setZoneAddMode: (mode: boolean) => void;
    loadZones: () => void;
    customZoneType?: number | null;
}

const WelcomeSmsZoneForm = (props: CountryGroupSelectInterface): React.ReactElement => {
    const ZONE_URL = '/mnc_codes';
    const COUNTRY_CODE_ZONE_URL = '/country_code_zones';
    const URL = '/zones';

    const dispatch = useDispatch();
    const { classes } = props;
    const tableStickyHeader = { root: classes.tableStickyHeader };

    const [afterFirstLoad, setAfterFirstLoad] = useState<boolean>(false);
    const [filters, setFilters] = useState<Array<Filter>>([{ name: 'customZoneType', value: 1 }]);
    const [orders, setOrders] = useState<Array<Order>>([]);
    const [zones, setZones] = useState<any>(null);
    const [reload, setReload] = useState<boolean>(false);
    const [selectedZoneFilters, setSelectedZoneFilters] = useState<Array<Filter>>([]);
    const [selectedZoneOrders, setSelectedZoneOrders] = useState<Array<Order>>([]);
    const [selectedZone, setSelectedZone] = useState<Array<number>>([]);
    const [selectedZoneObjects, setSelectedZoneObjects] = useState<any>(null);
    const [zoneName, setZoneName] = useState<string | null>(props.editZone ? props.editZone.mainname : null);

    const firstSerach = useCallback(() => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(ZONE_URL)),
            DISCOUNT_CONSTANTS.LIST,
            filters,
            orders,
            (data: any) => {
                setZones(data);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch, filters, orders]);

    const loadCountryZones = useCallback(() => {
        if (props.editZone) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(COUNTRY_CODE_ZONE_URL)),
                DISCOUNT_CONSTANTS.LIST,
                [
                    { name: 'zoneId', value: props.editZone.id },
                    { name: 'pagination', value: false },
                ],
                orders,
                (data: any) => {
                    if (data && data['hydra:member']) {
                        const assignedCcz: Array<number> = [];
                        data['hydra:member'].map((el: any) => {
                            assignedCcz.push(el.mncCodeId);
                        });

                        setSelectedZone(assignedCcz);
                        setSelectedZoneObjects(data);
                    }
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, props.editZone, orders]);

    const updateCallback = (
        event: any,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ): void => {
        setZoneName(event.target.value);
    };

    const saveSmsTemplate = (): void => {
        if (!props.editZone) {
            const outputObject = {
                mainname: zoneName,
                mncCodes: JSON.stringify(selectedZone),
                customZoneType: props.customZoneType ?? 1,
            };
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(URL, configDefault.PLATFORM_API_PREFIX)),
                platformGroupsConstants.ADD,
                outputObject,
                (data: any): void => {
                    props.setZoneAddMode(false);
                    props.loadZones();
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                    dispatchErrorAfterCallback: true,
                }
            );
        } else {
            const outputObject = {
                mainname: zoneName,
                mncCodes: JSON.stringify(selectedZone),
                customZoneType: props.customZoneType ?? 1,
            };
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.putWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(URL + '/' + props.editZone.id, configDefault.PLATFORM_API_PREFIX)),
                platformGroupsConstants.ADD,
                outputObject,
                (data: any): void => {
                    props.setZoneAddMode(false);
                    props.loadZones();
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                    dispatchErrorAfterCallback: true,
                }
            );
        }
    };

    const paginationCallbackFunction = (url: string): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(url),
            DISCOUNT_CONSTANTS.LIST,
            filters,
            orders,
            (data: any) => {
                setZones(data);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const clearFilter = (): void => {

        dispatch({
            type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
        });
        dispatch({
            type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            clearAll: true,
        });

        setFilters([{ name: 'customZoneType', value: 1 }]);
        setOrders([]);

        setReload(true)
    };


    useEffect(() => {
        if(reload){
            firstSerach()
            setReload(false)
        }
    }, [reload,firstSerach]);

    const updateOrderList = (orders: Array<Order>): void => setOrders(orders);
    const updateFilterList = (filters: Array<Filter>): void => setFilters(filters);

    const updateSelectedZonesOrderList = (orders: Array<Order>): void => {
        setSelectedZoneOrders(orders);
    };

    const updateSelectedZoneFiltersList = (filters: Array<Filter>): void => {
        setSelectedZoneFilters(filters);
    };

    const addToZone = (item: any): void => {
        if (!selectedZone.includes(item.id)) {
            setSelectedZone([...selectedZone, item.id]);
            let i = {
                mncCode: item,
                mncCodeId: item.id,
            };
            const newSelected = { ...selectedZoneObjects };
            if (newSelected && !newSelected['hydra:member']) {
                newSelected['hydra:member'] = [];
            }
            newSelected['hydra:member'].unshift(i);

            setSelectedZoneObjects(newSelected);
        }
    };
    const removeFromZone = (item: any): void => {
        if (selectedZone.includes(item.mncCodeId)) {
            let newElements = selectedZone.filter((mncCodeId: any) => {
                return mncCodeId !== parseInt(item.mncCodeId);
            });
            setSelectedZone(newElements);
            if (selectedZoneObjects && selectedZoneObjects['hydra:member']) {
                let newSelectedArr: Array<any> = [];
                const newSelected = { ...selectedZoneObjects };
                selectedZoneObjects['hydra:member'].map((el: any) => {
                    if (el.mncCodeId !== item.mncCodeId) {
                        newSelectedArr.push(el);
                    }
                });

                newSelected['hydra:member'] = newSelectedArr;

                setSelectedZoneObjects(newSelected);
            }
        }
    };

    useEffect(() => {
        if (selectedZone.length === 0 && !afterFirstLoad) {
            setAfterFirstLoad(true);
            firstSerach();
            loadCountryZones();
        }
    }, [firstSerach, loadCountryZones, selectedZone, afterFirstLoad]);

    const sort = (a: any, b: any): any => {
        let sortColumn = null;
        let sortColumnValue = null;
        if (selectedZoneOrders.length === 1) {
            sortColumn = selectedZoneOrders[0].name;
            sortColumnValue = selectedZoneOrders[0].value;
        }

        if (sortColumn !== null && sortColumnValue !== null) {
            if (a.mncCode[sortColumn].toLowerCase() < b.mncCode[sortColumn].toLowerCase()) {
                return sortColumnValue === 'asc' ? -1 : 1;
            }
            if (a.mncCode[sortColumn].toLowerCase() > b.mncCode[sortColumn].toLowerCase()) {
                return sortColumnValue === 'asc' ? 1 : -1;
            }
            return 0;
        }

        return 0;
    };

    return (
        <GridContainer spacing={2}>
            <GridItem xs={12}>
                <Card>
                    <CardBody>
                        <InputFormRest
                            stateName={'zoneName'}
                            callback={updateCallback}
                            stateObjectState={null}
                            typeField={'text'}
                            displayFieldName={'notifications:welcome_sms.zone_name'}
                            required={false}
                            value={zoneName}
                            vMin={4}
                            vMax={64}
                            typeCallback={'string'}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={5}>
                <Card>
                    <CardBody style={{ maxHeight: 980, overflow: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            <FilterList />
                                        </GridItem>
                                    </GridContainer>
                                </TableRow>
                                <TableRow>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                                        <TableHeaderContentCell textAlign="left" title="notifications:welcome_sms.actions" />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.country_name"
                                            fieldName="countryName"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={selectedZoneFilters}
                                            sort={selectedZoneOrders}
                                            updateOrderList={updateSelectedZonesOrderList}
                                            updateFilterList={updateSelectedZoneFiltersList}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.operator_name"
                                            fieldName="operatorName"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={selectedZoneFilters}
                                            sort={selectedZoneOrders}
                                            updateOrderList={updateSelectedZonesOrderList}
                                            updateFilterList={updateSelectedZoneFiltersList}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.mcc_code"
                                            fieldName="mccCode"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={selectedZoneFilters}
                                            sort={selectedZoneOrders}
                                            updateOrderList={updateSelectedZonesOrderList}
                                            updateFilterList={updateSelectedZoneFiltersList}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {selectedZone &&
                                    selectedZoneObjects &&
                                    selectedZoneObjects['hydra:member'].sort(sort).map((item: any, index: number) => {
                                        let show = true;
                                        selectedZoneFilters.map((filter) => {
                                            if (filter.name === 'countryName') {
                                                if (!item.mncCode['countryName'].includes(filter.value)) {
                                                    show = false;
                                                }
                                            }

                                            if (filter.name === 'operatorName') {
                                                if (!item.mncCode['operatorName'].includes(filter.value)) {
                                                    show = false;
                                                }
                                            }

                                            if (filter.name === 'mccCode') {
                                                if (!item.mncCode['mccCode'].includes(filter.value)) {
                                                    show = false;
                                                }
                                            }
                                        });

                                        if (!show) {
                                            return null;
                                        }

                                        return (
                                            <TableRow key={item.id}>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                                                    <RemoveButton callback={removeFromZone} callbackParam={item} />
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.mncCode.countryName}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.mncCode.operatorName}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.mncCode.mccCode}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={7}>
                <Card>
                    <CardBody>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            {/*Fitr na clearze ustawia sie zawsze na lenght 1*/}
                                            {(filters.length > 1 || orders.length > 0) && (
                                                <>
                                                    <CustomTextButtom size={'lg'} callback={firstSerach} callbackParam={{}} label="general:common.search" />
                                                <CustomTextButtom
                                                    callback={clearFilter}
                                                    callbackParam={{}}
                                                    color={'primary'}
                                                    size={'lg'}
                                                    label="general:common.clear"
                                                />
                                                </>

                                            )}
                                            <FilterList />
                                        </GridItem>
                                    </GridContainer>
                                </TableRow>
                                <TableRow>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                                        <TableHeaderContentCell textAlign="left" title="notifications:welcome_sms.actions" />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.country_name"
                                            fieldName="countryName"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={filters}
                                            sort={orders}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstSerach}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.operator_name"
                                            fieldName="operatorName"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={filters}
                                            sort={orders}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstSerach}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.country_code"
                                            fieldName="countryCode"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={filters}
                                            sort={orders}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstSerach}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.mcc_code"
                                            fieldName="mccCode"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={filters}
                                            sort={orders}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstSerach}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            textAlign="left"
                                            title="notifications:welcome_sms.mnc_code"
                                            fieldName="mncCode"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={filters}
                                            sort={orders}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstSerach}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {zones &&
                                    zones['hydra:member'].map((item: any) => {
                                        if (!item.mccCode) {
                                            return null;
                                        }
                                        return (
                                            <TableRow key={item.id}>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                                                    <AddButton callback={addToZone} disabled={selectedZone.includes(item.id)} callbackParam={item} />
                                                    {/*<Checkbox checked={selectedZone.includes(item.id)} onChange={change} name={item.id} />*/}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.countryName}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.operatorName}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.countryCode}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.mccCode}
                                                </TableCell>
                                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                                    {item.mncCode}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={10}>
                                        {zones && zones['hydra:view'] && <Pager callback={paginationCallbackFunction} views={zones} />}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12}>
                <CustomTextButtom size={'lg'} color={'primary'} callback={saveSmsTemplate} callbackParam={{}} label={'general:common.save'} />
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(WelcomeSmsZoneForm);
